// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Membership Page Styles */
:root {
  --primary-color: #144040;
  --primary-light: #1e6e64;
  --primary-dark: #0f3030;
  --secondary-color: #DCCA98;
  --secondary-light: #e5d8b7;
  --secondary-dark: #b8a87d;
  --text-light: #fff;
  --text-dark: #333333;
  --error-color: #e63946;
  --success-color: #2a9d8f;
}

/* Main container */
.membership-page {
  background-color: var(--primary-color);
  padding: 20px;
  padding-top: 100px;
  font-family: 'Arial, sans-serif';
  color: var(--secondary-color);
  min-height: 100vh;
}

/* Header section */
.membership-header {
  text-align: center;
  margin-bottom: 3rem;
  padding: 0 1rem;
  position: relative;
}

.membership-header:after {
  content: '';
  display: block;
  width: 200px;
  height: 2px;
  background-color: var(--secondary-color);
  margin: 2rem auto 0;
  opacity: 0.7;
}

.membership-header h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--secondary-color);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeIn 1s ease-in-out;
}

.membership-subtitle {
  font-size: 1.5rem;
  color: var(--secondary-light);
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.5;
}

/* Main content layout */
.membership-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto 4rem;
  padding: 0 1rem;
}

.membership-benefits-section {
  flex: 1 1;
  min-width: 300px;
  max-width: 800px;
}

/* Benefits cards */
.benefits-container {
  margin-bottom: 2rem;
}

.benefits-container h2 {
  font-size: 2.25rem;
  margin-bottom: 2rem;
  color: var(--secondary-color);
  text-align: center;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.benefit-card {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(220, 202, 152, 0.2);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  background-color: rgba(255, 255, 255, 0.08);
}

.benefit-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.05), transparent);
  transition: transform 0.6s ease;
  transform: translateX(-100%);
}

.benefit-card:hover::before {
  transform: translateX(100%);
}

.benefit-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  background-color: rgba(220, 202, 152, 0.2);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.benefit-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--secondary-color);
}

.benefit-card p {
  color: var(--text-light);
  line-height: 1.5;
}

/* Price card */
.membership-price-card {
  flex: 0 1 350px;
  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(220, 202, 152, 0.2);
  position: relative;
  overflow: hidden;
  height: -moz-fit-content;
  height: fit-content;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.membership-price-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.price-ribbon {
  position: absolute;
  top: 20px;
  right: -35px;
  background: var(--secondary-color);
  color: var(--primary-color);
  padding: 8px 40px;
  transform: rotate(45deg);
  font-weight: bold;
  font-size: 0.9rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.membership-price-card h2 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: var(--secondary-color);
  text-align: center;
}

.price-container {
  text-align: center;
  margin-bottom: 2rem;
}

.price-amount {
  font-size: 3.5rem;
  font-weight: bold;
  color: var(--secondary-color);
}

.price-period {
  font-size: 1.2rem;
  color: var(--secondary-light);
  margin-left: 0.5rem;
}

.price-features {
  list-style-type: none;
  padding: 0;
  margin-bottom: 2rem;
}

.price-features li {
  padding: 0.8rem 0;
  border-bottom: 1px solid rgba(220, 202, 152, 0.2);
  color: var(--text-light);
  display: flex;
  align-items: center;
}

.price-features li::before {
  content: "✓";
  color: var(--secondary-color);
  margin-right: 10px;
  font-weight: bold;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.primary-button {
  display: block;
  background: var(--secondary-color);
  color: var(--primary-dark);
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.primary-button:hover {
  background: var(--secondary-light);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.secondary-button {
  display: block;
  background: transparent;
  color: var(--secondary-color);
  text-align: center;
  padding: 1rem;
  border-radius: 8px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid var(--secondary-color);
  cursor: pointer;
  font-size: 1.1rem;
}

.secondary-button:hover {
  background: rgba(220, 202, 152, 0.1);
}

/* Testimonials section */
.testimonials-section {
  max-width: 1200px;
  margin: 0 auto 1rem;
  padding: 3rem 1rem;
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  position: relative;
}

.testimonials-section h2 {
  text-align: center;
  font-size: 2.25rem;
  margin-bottom: 3rem;
  color: var(--secondary-color);
}

.testimonials-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
}

.testimonial-card {
  flex: 1 1;
  min-width: 300px;
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 202, 152, 0.1);
  position: relative;
}

.testimonial-card::before {
  content: "\\201C";
  position: absolute;
  top: -10px;
  left: 20px;
  font-size: 6rem;
  color: rgba(220, 202, 152, 0.2);
  font-family: Georgia, serif;
  line-height: 1;
  z-index: 0;
}

.testimonial-content {
  position: relative;
  z-index: 1;
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--text-light);
  margin-bottom: 1.5rem;
}

.testimonial-author {
  text-align: right;
}

.author-name {
  font-weight: bold;
  color: var(--secondary-color);
  margin-bottom: 0.2rem;
}

.author-role {
  color: var(--secondary-light);
  font-size: 0.9rem;
}

/* Form section */
.membership-form-section {
  max-width: 900px;
  margin: 0 auto 0;
  padding: 1rem;
  position: relative;
}

.membership-form-section h2 {
  text-align: center;
  font-size: 2.25rem;
  margin-bottom: 0.5rem;
  color: var(--secondary-color);
}

.membership-form-section > p {
  text-align: center;
  margin-bottom: 3rem;
  color: var(--secondary-light);
}

.membership-form-container {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 202, 152, 0.1);
}

.membership-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-section {
  border-bottom: 1px solid rgba(220, 202, 152, 0.2);
  padding-bottom: 2rem;
}

.form-section:last-of-type {
  border-bottom: none;
}

.form-section h3 {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: var(--secondary-color);
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-group {
  flex: 1 1;
  min-width: 250px;
}

.form-row.two-columns .form-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 0.75rem);
}

.form-row.three-columns .form-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 1rem);
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--secondary-color);
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border-radius: 6px;
  border: 1px solid rgba(220, 202, 152, 0.3);
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--text-light);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--secondary-color);
  box-shadow: 0 0 0 2px rgba(220, 202, 152, 0.2);
}

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: var(--error-color);
}

.error-message {
  color: var(--error-color);
  font-size: 0.9rem;
  margin-top: 0.5rem;
  display: block;
}

.error-message.submit-error {
  text-align: center;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background-color: rgba(230, 57, 70, 0.1);
  border-radius: 6px;
}

.form-actions {
  text-align: center;
  margin-top: 1rem;
}

.submit-button {
  padding: 1rem 2rem;
  border-radius: 8px;
  border: none;
  background-color: var(--secondary-color);
  color: var(--primary-dark);
  font-weight: bold;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 1rem;
  min-width: 200px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.submit-button:hover:not(:disabled) {
  background-color: var(--secondary-light);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-disclaimer {
  font-size: 0.9rem;
  color: var(--secondary-light);
}

.form-disclaimer a {
  color: var(--secondary-color);
  text-decoration: underline;
}

.success-message {
  text-align: center;
  padding: 3rem 2rem;
}

.success-message h3 {
  font-size: 2rem;
  color: var(--success-color);
  margin-bottom: 1rem;
}

.success-message p {
  font-size: 1.2rem;
  color: var(--text-light);
}

/* FAQ section */
.faq-section {
  max-width: 900px;
  margin: 0 auto 5rem;
  padding: 1rem;
}

.faq-section h2 {
  text-align: center;
  font-size: 2.25rem;
  margin-bottom: 3rem;
  color: var(--secondary-color);
}

.faq-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 2rem;
}

.faq-item {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(220, 202, 152, 0.1);
}

.faq-item h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--secondary-color);
}

.faq-item p {
  color: var(--text-light);
  line-height: 1.5;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .membership-header h1 {
    font-size: 2.2rem;
  }
  
  .membership-subtitle {
    font-size: 1.2rem;
  }
  
  .membership-content {
    flex-direction: column;
  }
  
  .membership-price-card {
    order: -1;
    max-width: 100%;
  }
  
  .faq-items {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .form-row.two-columns, 
  .form-row.three-columns {
    flex-direction: column;
  }
  
  .form-row.two-columns .form-group,
  .form-row.three-columns .form-group {
    min-width: 100%;
  }
  
  .testimonials-container {
    flex-direction: column;
  }
}

.form-group select option {
  color: #000000;
  background-color: #ffffff;
}

/* Section dividers */
.section-divider {
  width: 100%;
  max-width: 800px;
  height: 2px;
  background-color: var(--secondary-color);
  margin: 5rem auto;
  opacity: 0.3;
  position: relative;
}

.section-divider:before {
  content: '';
  position: absolute;
  width: 50px;
  height: 4px;
  background-color: var(--secondary-color);
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.8;
} `, "",{"version":3,"sources":["webpack://./src/membership/MembershipPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uFAAuF;EACvF,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,+EAA+E;EAC/E,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,wBAAwB;EACxB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;AAC/B;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd","sourcesContent":["/* Membership Page Styles */\n:root {\n  --primary-color: #144040;\n  --primary-light: #1e6e64;\n  --primary-dark: #0f3030;\n  --secondary-color: #DCCA98;\n  --secondary-light: #e5d8b7;\n  --secondary-dark: #b8a87d;\n  --text-light: #fff;\n  --text-dark: #333333;\n  --error-color: #e63946;\n  --success-color: #2a9d8f;\n}\n\n/* Main container */\n.membership-page {\n  background-color: var(--primary-color);\n  padding: 20px;\n  padding-top: 100px;\n  font-family: 'Arial, sans-serif';\n  color: var(--secondary-color);\n  min-height: 100vh;\n}\n\n/* Header section */\n.membership-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  padding: 0 1rem;\n  position: relative;\n}\n\n.membership-header:after {\n  content: '';\n  display: block;\n  width: 200px;\n  height: 2px;\n  background-color: var(--secondary-color);\n  margin: 2rem auto 0;\n  opacity: 0.7;\n}\n\n.membership-header h1 {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  color: var(--secondary-color);\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 1s ease-in-out;\n}\n\n.membership-subtitle {\n  font-size: 1.5rem;\n  color: var(--secondary-light);\n  max-width: 800px;\n  margin: 0 auto;\n  line-height: 1.5;\n}\n\n/* Main content layout */\n.membership-content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 3rem;\n  max-width: 1200px;\n  margin: 0 auto 4rem;\n  padding: 0 1rem;\n}\n\n.membership-benefits-section {\n  flex: 1;\n  min-width: 300px;\n  max-width: 800px;\n}\n\n/* Benefits cards */\n.benefits-container {\n  margin-bottom: 2rem;\n}\n\n.benefits-container h2 {\n  font-size: 2.25rem;\n  margin-bottom: 2rem;\n  color: var(--secondary-color);\n  text-align: center;\n}\n\n.benefits-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.benefit-card {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 1.5rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(220, 202, 152, 0.2);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.benefit-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.benefit-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.05), transparent);\n  transition: transform 0.6s ease;\n  transform: translateX(-100%);\n}\n\n.benefit-card:hover::before {\n  transform: translateX(100%);\n}\n\n.benefit-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  background-color: rgba(220, 202, 152, 0.2);\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.benefit-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: var(--secondary-color);\n}\n\n.benefit-card p {\n  color: var(--text-light);\n  line-height: 1.5;\n}\n\n/* Price card */\n.membership-price-card {\n  flex: 0 1 350px;\n  background: linear-gradient(135deg, var(--primary-light), var(--primary-color));\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(220, 202, 152, 0.2);\n  position: relative;\n  overflow: hidden;\n  height: fit-content;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.membership-price-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);\n}\n\n.price-ribbon {\n  position: absolute;\n  top: 20px;\n  right: -35px;\n  background: var(--secondary-color);\n  color: var(--primary-color);\n  padding: 8px 40px;\n  transform: rotate(45deg);\n  font-weight: bold;\n  font-size: 0.9rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n\n.membership-price-card h2 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: var(--secondary-color);\n  text-align: center;\n}\n\n.price-container {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.price-amount {\n  font-size: 3.5rem;\n  font-weight: bold;\n  color: var(--secondary-color);\n}\n\n.price-period {\n  font-size: 1.2rem;\n  color: var(--secondary-light);\n  margin-left: 0.5rem;\n}\n\n.price-features {\n  list-style-type: none;\n  padding: 0;\n  margin-bottom: 2rem;\n}\n\n.price-features li {\n  padding: 0.8rem 0;\n  border-bottom: 1px solid rgba(220, 202, 152, 0.2);\n  color: var(--text-light);\n  display: flex;\n  align-items: center;\n}\n\n.price-features li::before {\n  content: \"✓\";\n  color: var(--secondary-color);\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.cta-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.primary-button {\n  display: block;\n  background: var(--secondary-color);\n  color: var(--primary-dark);\n  text-align: center;\n  padding: 1rem;\n  border-radius: 8px;\n  font-weight: bold;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  font-size: 1.1rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.primary-button:hover {\n  background: var(--secondary-light);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.secondary-button {\n  display: block;\n  background: transparent;\n  color: var(--secondary-color);\n  text-align: center;\n  padding: 1rem;\n  border-radius: 8px;\n  font-weight: bold;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border: 1px solid var(--secondary-color);\n  cursor: pointer;\n  font-size: 1.1rem;\n}\n\n.secondary-button:hover {\n  background: rgba(220, 202, 152, 0.1);\n}\n\n/* Testimonials section */\n.testimonials-section {\n  max-width: 1200px;\n  margin: 0 auto 1rem;\n  padding: 3rem 1rem;\n  background-color: rgba(255, 255, 255, 0.03);\n  border-radius: 12px;\n  position: relative;\n}\n\n.testimonials-section h2 {\n  text-align: center;\n  font-size: 2.25rem;\n  margin-bottom: 3rem;\n  color: var(--secondary-color);\n}\n\n.testimonials-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  justify-content: center;\n}\n\n.testimonial-card {\n  flex: 1;\n  min-width: 300px;\n  max-width: 500px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 2rem;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(220, 202, 152, 0.1);\n  position: relative;\n}\n\n.testimonial-card::before {\n  content: \"\\201C\";\n  position: absolute;\n  top: -10px;\n  left: 20px;\n  font-size: 6rem;\n  color: rgba(220, 202, 152, 0.2);\n  font-family: Georgia, serif;\n  line-height: 1;\n  z-index: 0;\n}\n\n.testimonial-content {\n  position: relative;\n  z-index: 1;\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: var(--text-light);\n  margin-bottom: 1.5rem;\n}\n\n.testimonial-author {\n  text-align: right;\n}\n\n.author-name {\n  font-weight: bold;\n  color: var(--secondary-color);\n  margin-bottom: 0.2rem;\n}\n\n.author-role {\n  color: var(--secondary-light);\n  font-size: 0.9rem;\n}\n\n/* Form section */\n.membership-form-section {\n  max-width: 900px;\n  margin: 0 auto 0;\n  padding: 1rem;\n  position: relative;\n}\n\n.membership-form-section h2 {\n  text-align: center;\n  font-size: 2.25rem;\n  margin-bottom: 0.5rem;\n  color: var(--secondary-color);\n}\n\n.membership-form-section > p {\n  text-align: center;\n  margin-bottom: 3rem;\n  color: var(--secondary-light);\n}\n\n.membership-form-container {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(220, 202, 152, 0.1);\n}\n\n.membership-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.form-section {\n  border-bottom: 1px solid rgba(220, 202, 152, 0.2);\n  padding-bottom: 2rem;\n}\n\n.form-section:last-of-type {\n  border-bottom: none;\n}\n\n.form-section h3 {\n  margin-bottom: 1.5rem;\n  font-size: 1.5rem;\n  color: var(--secondary-color);\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n.form-group {\n  flex: 1;\n  min-width: 250px;\n}\n\n.form-row.two-columns .form-group {\n  flex: 1 1 calc(50% - 0.75rem);\n}\n\n.form-row.three-columns .form-group {\n  flex: 1 1 calc(33% - 1rem);\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--secondary-color);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border-radius: 6px;\n  border: 1px solid rgba(220, 202, 152, 0.3);\n  background-color: rgba(255, 255, 255, 0.1);\n  color: var(--text-light);\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--secondary-color);\n  box-shadow: 0 0 0 2px rgba(220, 202, 152, 0.2);\n}\n\n.form-group input.error,\n.form-group select.error,\n.form-group textarea.error {\n  border-color: var(--error-color);\n}\n\n.error-message {\n  color: var(--error-color);\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.error-message.submit-error {\n  text-align: center;\n  margin-bottom: 1rem;\n  padding: 0.5rem;\n  background-color: rgba(230, 57, 70, 0.1);\n  border-radius: 6px;\n}\n\n.form-actions {\n  text-align: center;\n  margin-top: 1rem;\n}\n\n.submit-button {\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  border: none;\n  background-color: var(--secondary-color);\n  color: var(--primary-dark);\n  font-weight: bold;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 1rem;\n  min-width: 200px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.submit-button:hover:not(:disabled) {\n  background-color: var(--secondary-light);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.form-disclaimer {\n  font-size: 0.9rem;\n  color: var(--secondary-light);\n}\n\n.form-disclaimer a {\n  color: var(--secondary-color);\n  text-decoration: underline;\n}\n\n.success-message {\n  text-align: center;\n  padding: 3rem 2rem;\n}\n\n.success-message h3 {\n  font-size: 2rem;\n  color: var(--success-color);\n  margin-bottom: 1rem;\n}\n\n.success-message p {\n  font-size: 1.2rem;\n  color: var(--text-light);\n}\n\n/* FAQ section */\n.faq-section {\n  max-width: 900px;\n  margin: 0 auto 5rem;\n  padding: 1rem;\n}\n\n.faq-section h2 {\n  text-align: center;\n  font-size: 2.25rem;\n  margin-bottom: 3rem;\n  color: var(--secondary-color);\n}\n\n.faq-items {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 2rem;\n}\n\n.faq-item {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(220, 202, 152, 0.1);\n}\n\n.faq-item h3 {\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  color: var(--secondary-color);\n}\n\n.faq-item p {\n  color: var(--text-light);\n  line-height: 1.5;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .membership-header h1 {\n    font-size: 2.2rem;\n  }\n  \n  .membership-subtitle {\n    font-size: 1.2rem;\n  }\n  \n  .membership-content {\n    flex-direction: column;\n  }\n  \n  .membership-price-card {\n    order: -1;\n    max-width: 100%;\n  }\n  \n  .faq-items {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-row.two-columns, \n  .form-row.three-columns {\n    flex-direction: column;\n  }\n  \n  .form-row.two-columns .form-group,\n  .form-row.three-columns .form-group {\n    min-width: 100%;\n  }\n  \n  .testimonials-container {\n    flex-direction: column;\n  }\n}\n\n.form-group select option {\n  color: #000000;\n  background-color: #ffffff;\n}\n\n/* Section dividers */\n.section-divider {\n  width: 100%;\n  max-width: 800px;\n  height: 2px;\n  background-color: var(--secondary-color);\n  margin: 5rem auto;\n  opacity: 0.3;\n  position: relative;\n}\n\n.section-divider:before {\n  content: '';\n  position: absolute;\n  width: 50px;\n  height: 4px;\n  background-color: var(--secondary-color);\n  top: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0.8;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
